import type { StoryDiscussion } from '../types';
import { commentPlatformLabel } from '../utils/commentPlatform';
import { safeHref } from '../utils/html';

interface DiscussionSectionProps {
  discussion: StoryDiscussion;
  onLinkClick?: () => void;
}

export function DiscussionSection({ discussion, onLinkClick }: DiscussionSectionProps) {
  const picks = discussion.top_comments?.slice(0, 3) ?? [];
  if (!discussion.summary && picks.length === 0) return null;

  return (
    <section className="feed-item-expanded-section">
      <div className="feed-item-section-header">Notable comments</div>
      {discussion.summary && (
        <ul className="feed-item-context-list">
          <li className="feed-item-context-fact">{discussion.summary}</li>
        </ul>
      )}
      {picks.length > 0 && (
        <ul className="feed-item-discussion-picks">
          {picks.map((c) => (
            <li key={c.platform_id} className="feed-item-discussion-pick">
              <a
                href={safeHref(c.permalink)}
                target="_blank"
                rel="noopener noreferrer"
                className="feed-item-discussion-pick-link"
                onClick={onLinkClick}
              >
                <span className="feed-item-discussion-pick-meta">
                  {commentPlatformLabel(c.platform)}
                  {c.author ? ` · ${c.author}` : ''}
                  {typeof c.score === 'number' ? ` · ${c.score}` : ''}
                </span>
                <span className="feed-item-discussion-pick-summary">
                  {c.summary}
                </span>
              </a>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
